// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YUni","textarea":"styles_textarea__3gWY9"};